export default "__VITE_ASSET__DJR1EOKB__"